// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"OfferEquipment_wrapper__FEp4g","h":"OfferEquipment_h__L3V85","opt":"OfferEquipment_opt__v_7at"};